import { render, staticRenderFns } from "./default-action-output.vue?vue&type=template&id=4fb37a46&scoped=true"
import script from "./default-action-output.vue?vue&type=script&lang=js"
export * from "./default-action-output.vue?vue&type=script&lang=js"
import style0 from "./default-action-output.vue?vue&type=style&index=0&id=4fb37a46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb37a46",
  null
  
)

export default component.exports